import { formatSearchParams } from '#types/filters';
import { SearchParams, Teaser } from '#types/generated/graphql-types';

export type State = {
  loading: boolean;
  result: Teaser[];
  open: boolean;
  query: string;
  countResult: {
    count: number | null;
    loading: boolean;
  };
  filters: {
    years: Set<string>; // Represent a year as a string to avoid unnecessary fights with the type system
    categorySlugs: Set<string>;
    [key: string]: Set<string>;
  };
};

export const state: State = {
  loading: false,
  result: [],
  open: false,
  query: '',
  countResult: {
    count: null,
    loading: false,
  },
  filters: {
    years: new Set(),
    categorySlugs: new Set(),
  },
};

export const convertStateToSearchParams = (
  filters: State['filters']
): SearchParams => {
  const intermediate: Record<string, string | string[] | undefined> = {};

  Object.keys(filters).forEach((key) => {
    const value = filters[key];
    if (value instanceof Set && value.size > 0) {
      intermediate[key] = Array.from(value);
    }
  });

  return formatSearchParams(intermediate);
};
